import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../../services/authService";
import "./r_sign_in 1.css";

// The native <input type="email"> constraint validation accepts things like
// "test@test" (no TLD required) - too loose to actually catch a mistyped
// address, which is exactly what was slipping through here.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const R_ForgotPassword: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const isDisabled = loading || !email.trim();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isDisabled) return;

        setError(null);
        const trimmedEmail = email.trim();

        if (!EMAIL_REGEX.test(trimmedEmail)) {
            setError("Please enter a valid email address.");
            return;
        }

        try {
            setLoading(true);
            await authService.otpRequest({ email: trimmedEmail, purpose: "password_reset" });
            navigate("/forgot-password/verify", { state: { email: trimmedEmail } });
        } catch (err: any) {
            setError(err?.message || "Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <div className="keep-box-in-center">
                <img src="/images/right-emails-logo.svg" className="form-logo" alt="Right Emails" />

                <div className="form-box">
                    <p className="form-header">Forgot Password</p>
                    <p className="form-inform">
                        Enter your registered email address and we'll send you a code to reset your password
                    </p>

                    <form onSubmit={handleSubmit}>
                        <div className="tch-section">
                            <label className="r-form-label">Email</label>
                            <input
                                type="email"
                                name="email"
                                className="r-form-email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    if (error) setError(null);
                                }}
                                required
                                disabled={loading}
                            />
                            {error && <p className="field-error-text">{error}</p>}
                        </div>

                        <button
                            type="submit"
                            className={`form-submit ${loading ? "disabled" : ""}`}
                            disabled={isDisabled}
                        >
                            {loading ? "Sending..." : "Send OTP"}
                        </button>
                    </form>

                    <p className="asking">
                        Remembered your password?{" "}
                        <span className="ask-sign-up" onClick={() => navigate("/login")}>
                            Back to Login
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default R_ForgotPassword;
